import React, { useEffect, useState } from 'react';
import { getTheme, setUserTheme } from '../utils/darkmode';

const ThemeToggle = () => {
    const currentTheme = getTheme();
    const [isDark, setDark] = useState(currentTheme === 'dark');
    const [currentToggleImage, setCurrentToggleImage] = useState();
    const [altText, setAltText] = useState();

    useEffect(() => {
        setCurrentToggleImage(
            currentTheme === 'dark'
                ? '/icons/icon_light_mode.svg'
                : '/icons/icon_dark_mode.svg',
        );
        setAltText(
            currentTheme === 'dark'
                ? 'Activate Light Mode'
                : 'Activate Dark Mode',
        );
    }, [currentTheme]);

    const handleClick = () => {
        setDark(!isDark);
        setUserTheme(!isDark ? 'dark' : 'red');
    };
    return (
        <button onClick={handleClick}>
            <img src={currentToggleImage} alt={altText} />
        </button>
    );
};

export default ThemeToggle;
